import React, { useState } from 'react';
import UsersAPI from 'api/UsersAPI';
import { useSnackbar } from 'notistack';
import BackButton from '../../components/Common/BackButton';

const AdminCreateUser: React.FC = () => {
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    emailVerified: false,
    enabled: true,
    credentials: [
      {
        type: 'password',
        value: 'BitePassword2026!', // temporary password
        temporary: true, // forces user to change on first login
      },
    ],
  });
  const [errors, setErrors] = useState<any>({});
  const { enqueueSnackbar } = useSnackbar();

  const validate = () => {
    const newErrors: any = {};
    if (!form.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      newErrors.email = 'Invalid email address';
    }
    if (!form.firstName) {
      newErrors.firstName = 'First name is required';
    }
    if (!form.lastName) {
      newErrors.lastName = 'Last name is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const submitCreateUser = async () => {
    if (!validate()) {
      return;
    }
    // Check for already existing user by email
    const existing = await UsersAPI.checkExistingUser(form);
    if (existing?.success) {
      if (existing?.result === true) {
        enqueueSnackbar('User already exists', { variant: 'error' });
        // Create user if not found
      } else {
        const res = await UsersAPI.createUser(form);
        if (res?.success) {
          setForm({
            firstName: '',
            lastName: '',
            email: '',
            emailVerified: false,
            enabled: true,
            credentials: [
              {
                type: 'password',
                value: 'BitePassword2026!', // temporary password
                temporary: true, // forces user to change on first login
              },
            ],
          });
          enqueueSnackbar('User created successfully', { variant: 'success' });
        } else {
          enqueueSnackbar('Failed to create new user.', { variant: 'error' });
        }
      }
    }
  };

  const update = (key: string, value: any) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const row = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '14px',
    width: '100%',
  };

  const label = {
    width: '30%',
    fontWeight: '400',
    color: 'var(--text-primary-color)',
  };

  const input = {
    flex: 1,
    padding: '10px 12px',
    borderRadius: '8px',
    border: '1px solid var(--es-soft-border)',
    background: 'var(--Background-200, var(--bg-colors))',
    color: 'var(--text-primary-color)',
    outline: 'none',
    width: '100%',
    minWidth: 0,
    boxShadow: 'var(--es-card-shadow)',
  };

  const inputReadOnly = {
    flex: 1,
    width: '100%',
    minWidth: 0,
    padding: '10px 12px',
    borderRadius: '8px',
    border: '1px solid var(--es-soft-border)',
    background: 'var(--bg-surface)', // inset surface to show read-only
    color: 'var(--text-secondary)',
    outline: 'none',
    boxShadow: 'var(--es-card-shadow)',
  };

  return (
    <div
      style={{
        padding: '25px',
        minHeight: 'calc(100vh - 120px)',
      }}
    >
      <BackButton />
      <div
        style={{
          fontSize: '22px',
          fontWeight: '500',
          color: 'var(--workflow-text)',
          marginBottom: '10px',
          padding: '10px 0px',
          borderBottom: '1px solid var(--es-soft-border)',
          letterSpacing: '0.5px',
        }}
      >
        Create New User
      </div>
      <div
        style={{
          padding: '10px 28px',
          borderRadius: '14px',
        }}
      >
        <div style={row}>
          <div style={label}>First Name</div>
          <div style={{ flex: 1 }}>
            <input
              style={input}
              value={form.firstName}
              onChange={(e) => update('firstName', e.target.value)}
            />
            {errors.firstName && (
              <p style={{ color: 'var(--low-color)' }}>{errors.firstName}</p>
            )}
          </div>
        </div>
        <div style={row}>
          <div style={label}>Last Name</div>
          <div style={{ flex: 1 }}>
            <input
              style={input}
              value={form.lastName}
              onChange={(e) => update('lastName', e.target.value)}
            />
            {errors.lastName && (
              <p style={{ color: 'var(--low-color)' }}>{errors.lastName}</p>
            )}
          </div>
        </div>
        <div style={row}>
          <div style={label}>Email</div>
          <div style={{ flex: 1 }}>
            <input
              style={input}
              value={form.email}
              onChange={(e) => update('email', e.target.value)}
            />
            {errors.email && <p style={{ color: 'var(--low-color)' }}>{errors.email}</p>}
          </div>
        </div>
        <div style={row}>
          <div style={label}>Username</div>
          <div style={{ flex: 1 }}>
            <input style={inputReadOnly} value={form.email} readOnly />
          </div>
        </div>
      </div>
      <div style={{ marginTop: '24px', textAlign: 'right' }}>
        <button
          style={{
            padding: '10px 20px',
            backgroundColor: '#3b82f6', // blue-500
            color: '#fff',
            fontWeight: '600',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
          }}
          // eslint-disable-next-line no-return-assign
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = '#2563eb')
          } // blue-600
          // eslint-disable-next-line no-return-assign
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = '#3b82f6')
          }
          onClick={() => submitCreateUser()}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default AdminCreateUser;
